export default __webpack_public_path__ + "static/media/superlogica_icon.63fa79e9.svg";